module.exports = __webpack_public_path__ + "vrplayerstatic/media/gCardboard.421ef243.svg";